import { useDispatch, useSelector } from 'react-redux'

import { initializingSelector, selectedSuggestionsSelector } from './selectors'
import { removeSelectedSuggestion, updateOrgAdminToRemove } from './slice'

export const SelectedSuggestionsContainer = ({
  component: Component,
  showUserRole,
  showOrgAdminRemoval,
  isSuggestionRemovable,
  isSuggestionDisabled,
  onRemove
}) => {
  const dispatch = useDispatch()
  const isLoading = useSelector(initializingSelector)
  const selectedSuggestions = useSelector(selectedSuggestionsSelector)

  const handleRemove = (suggestion, index) => {
    dispatch(removeSelectedSuggestion(suggestion))
    if (onRemove) onRemove(suggestion.entity, index)
  }

  const onChange = (isOrgAdminToRemove, suggestion) => {
    if (showOrgAdminRemoval) {
      dispatch(updateOrgAdminToRemove({ isOrgAdminToRemove, type: suggestion.type, entity: suggestion.entity }))
    }
  }

  return (
    <Component
      suggestions={selectedSuggestions}
      onRemove={handleRemove}
      onChange={onChange}
      isLoading={isLoading}
      showUserRole={showUserRole}
      showOrgAdminRemoval={showOrgAdminRemoval}
      isSuggestionRemovable={isSuggestionRemovable}
      isSuggestionDisabled={isSuggestionDisabled}
    />
  )
}
